<template>

  <div>
    <div  v-if="isScrolled9">
      <Header1/>
    </div>
    <div style="height: 5em;"></div>
    <div style="display: flex;justify-content: center">
      <div>

        <div style="display: flex;justify-content: center">
          <div style="width: 60%  ">
            <div>
              <div>
                <div style="font-size: larger;text-align: left;margin-top: 20px; width: 60% ">
                <div style="width: 60em">  <el-link @click="jump" :underline="false" style="font-size: medium">首页</el-link> >  <el-link @click="jump1" :underline="false" style="font-size: medium">新闻资讯</el-link>>  <el-link :underline="false" style="font-size: medium">行业新闻</el-link></div>
               </div>
              </div>
              <div >
                <h1 style="display: flex;justify-content: center;margin: 50px 0">{{sdkIndex}}</h1>
                <editor v-model="htmlContent" :min-height="192"/>
              </div>
            </div>
            <!--  <vue-markdown :source="htmlContent" />-->
          </div>
        </div>
        <!--<div v-html="htmlContent"></div>-->
      </div>
    </div>
<Footer/>
  </div>
</template>

<script>
import Header1 from "@/views/header1.vue";
import { pdfjs } from 'vue-pdf';
import VuePdf from 'vue-pdf';
import pdfSrc from '@/assets/pdf/picSdk.pdf';
import pdfSrc1 from '@/assets/pdf/medicalImageSdk.pdf';
import pdfSrc2 from '@/assets/pdf/text&logSdk.pdf';
import VueMarkdown from 'vue-markdown';
import Footer from "@/views/footer.vue";

export default {
  components: {
    Header1,
    Footer,
    pdf: VuePdf,
    VueMarkdown
  },
  data() {
    return {
      isScrolled9: true,
      htmlContent:'',
      seoDescription:'',
      data:[],
      sdkShow:false,
      sdkShow1:false,
      sdkShow2:false,
      sdkIndex:0,
      pdfSrc: pdfSrc, // 替换为你的 PDF 文件路径
      pdfSrc1: pdfSrc1,
      pdfSrc2: pdfSrc2,
      pageNumber: 1,
      numPages: 0,
      pageWidth: 500, // 设置页面宽度，可以根据需要调整
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll9);
    // this.sdkIndex =this.$route.params.a
    this.sdkIndex=sessionStorage.getItem('x');
    console.log( this.sdkIndex)

this.getData()



  },
  methods: {
    handleScroll9() {
      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;

      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false
        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true
        this.isScrolled9 = true;
      }
      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;
      // // 当滚动距离小于等于200px时，设置isScrolled9为true
      // this.isScrolled9 = scrollDistance <=500;

    },
    jump(){
      this.$router.push({path:"/"})
    },
    jump1(){
      this.$router.push({path:"case"})
    },
    updateHtmlContent() {
      // Simulating the v-html behavior using JavaScript
      const divElement = document.getElementById('app');
      divElement.innerHTML = this.htmlContent;
    },
    getData() {


      const headers = {};

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http.get('yasubit/website/9', { headers })
          .then(response => {
            // 请求成功时更新数据
            console.log(8888);
            this.data = response.data;
            // console.log( this.data.data)


            const data =this.data.data;

            this.data=data[0].children[0].archiveList
            console.log(this.data)





// 例如，使用函数获取"深度学习之图像视频压缩技术"的seoDescription
            this.htmlContent = this.getSeoDescriptionByTitle(this.sdkIndex);



           //
           // this.htmlContent= this.doubleEscapeHtml( this.htmlContent)
           //  const a= this.htmlContent
            this.htmlContent= this.convertAndAppendHTML( this.htmlContent)


            console.log( this.htmlContent);









          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });


    },
    //在数组中遍历找到一层的对象中的值的同层的值
    getSeoDescriptionByTitle(title) {
  // 查找与给定title匹配的对象
  const matchedItem = this.data.find(item => item.title === title);

  // 如果找到匹配的对象，则返回其seoDescription；否则返回空字符串或其他默认值
  return matchedItem ? matchedItem.content : '';

},
    doubleEscapeHtml(content) {

      // 第一次转义
      const firstEscape = content.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      // 第二次转义
      firstEscape.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return firstEscape;
    },
    convertAndAppendHTML(encodedText) {
      const decodedElement = document.createElement('div');
      decodedElement.innerHTML = encodedText;
      return decodedElement.innerHTML;
    },
    setNumPages(numPages) {
      this.numPages = numPages;
    },
    prevPage() {
      if (this.pageNumber > 1) {
        this.pageNumber -= 1;
      }
    },
    nextPage() {
      if (this.pageNumber < this.numPages) {
        this.pageNumber += 1;
      }
    },
  },
};
</script>
